import React from 'react';
import path from 'path';
import { useTranslation } from 'react-i18next';

import { Picture } from 'formlabs-web-components/Media';

const RegionFlag = ({ region, fallback, size }) => {
  const { t } = useTranslation();

  return (
    <Picture
      largeImage={
        region
          ? path.join(
              process.env.PUBLIC_PATH,
              `flags/${region.toLowerCase()}.svg`
            )
          : fallback || null
      }
      width={size || 32}
      alt={t('country flag')}
    />
  );
};

export default RegionFlag;
